import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-invoice-count',
    templateUrl: './invoice-count.component.html',
    styleUrls: ['./invoice-count.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoiceCountComponent implements OnInit {
  constructor() {}

  @Input() number: number;

  ngOnInit() {}
}
